/**
 * Adds a value to the array in query state if it's not already included.
 * @param value The value to add.
 * @param setSelected The setter function returned by useQueryState.
 * @example
 * handleAddToQuery("PIX", setSelectedPaymentMethods);
 */
export function handleAddToQuery<T>(
  value: T,
  setSelected: (updater: (prev: T[]) => T[]) => void,
) {
  setSelected((prev) => (prev.includes(value) ? prev : [...prev, value]));
}

/**
 * Removes a value from the array in query state if it's included.
 * @param value The value to remove.
 * @param setSelected The setter function returned by useQueryState.
 * @example
 * handleRemoveFromQuery("PIX", setSelectedPaymentMethods);
 */
export function handleRemoveFromQuery<T>(
  value: T,
  setSelected: (updater: (prev: T[]) => T[]) => void,
) {
  setSelected((prev) => prev.filter((item) => item !== value));
}
